export default __webpack_public_path__ + "measure-500-8a5223b69b8d3ca022cfcc9b3f180db4.webp";